import gql from 'graphql-tag';

export const UPDATE_MYPAGE_PASSWORD = gql`
    mutation ($old_password: String, $password: String, $password_confirmation: String) {
        memberUpdatePassword(
            old_password: $old_password,
            password: $password,
            password_confirmation: $password_confirmation
        ){
            result
        }
    },
`;